export default __webpack_public_path__ + "static/media/whatsapp-icon.a40b60f6.svg";